import React, { useState, useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom';
import { isMobile, isTablet } from 'react-device-detect';

export default function DeliveryOrderDiscount() {
  const deliveryOrderId = useParams().id;
  const [searchParams] = useSearchParams();
  const showReserved = searchParams.get('showReserved') === 'true';
  const [showIframe, setShowIframe] = useState(false);
  const dataUrl = `https://rlugroup.in/api/delivery-orders/data-with-discount/${deliveryOrderId}${showReserved ? '?showReserved=true' : ''}`;
  const url = `https://rlugroup.in/pdf/convert?fileName=rlugroup-delivery-order-discount.hbs&id_field=doNumber&format=A5&margintop=0.2cm&url=${dataUrl}`;
  
  // isMobile from react-device-detect excludes tablets automatically
  const isMobilePhone = isMobile && !isTablet;

  const handleDownload = async () => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `delivery-order-discount-${deliveryOrderId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Download failed:', error);
      // Fallback to opening in new tab
      window.open(url, '_blank');
    }
  };
  
  useEffect(() => {
    // Delay iframe rendering to ensure PDF service is ready (for desktop and tablets only)
    if (!isMobilePhone) {
      setTimeout(() => setShowIframe(true), 150);
    }
  }, [isMobilePhone]);
  
  if (isMobilePhone) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '20px',
        textAlign: 'center',
        backgroundColor: '#f3f4f6'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '40px 30px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          maxWidth: '400px',
          width: '100%'
        }}>
          <div style={{ marginBottom: '20px' }}>
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ margin: '0 auto' }}>
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <polyline points="14 2 14 8 20 8" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="12" y1="18" x2="12" y2="12" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="9" y1="15" x2="12" y2="18" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="15" y1="15" x2="12" y2="18" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 style={{ 
            marginBottom: '10px', 
            color: '#374151',
            fontSize: '24px',
            fontWeight: '600'
          }}>
            Delivery Order PDF
          </h2>
          <p style={{ 
            color: '#6B7280', 
            marginBottom: '30px',
            fontSize: '14px',
            lineHeight: '1.5'
          }}>
            For the best experience on mobile devices, please download the PDF to view it.
          </p>
          <button 
            onClick={handleDownload}
            style={{
              display: 'block',
              width: '100%',
              padding: '14px 24px',
              backgroundColor: '#3B82F6',
              color: 'white',
              borderRadius: '8px',
              border: 'none',
              fontWeight: '600',
              fontSize: '16px',
              marginBottom: '12px',
              boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
              transition: 'all 0.2s',
              cursor: 'pointer'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#2563EB'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#3B82F6'}
          >
            📥 Download PDF
          </button>
          <a 
            href={url} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'block',
              padding: '12px 24px',
              backgroundColor: 'transparent',
              color: '#3B82F6',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '500',
              fontSize: '14px',
              border: '2px solid #3B82F6'
            }}
          >
            Open in New Tab
          </a>
        </div>
      </div>
    );
  }
  
  return (
    <div style={{ width: '100%', height: '100vh', margin: 0, padding: 0, overflow: 'hidden', backgroundColor: '#525659' }}>
      {!showIframe && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          color: '#fff'
        }}>
          Loading PDF...
        </div>
      )}
      {showIframe && (
        <object 
          data={url}
          type="application/pdf"
          width="100%" 
          height="100%"
          aria-label="Delivery Order PDF with Discount"
        >
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            padding: '20px',
            textAlign: 'center',
            backgroundColor: '#f3f4f6'
          }}>
            <div style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              padding: '40px 30px',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              maxWidth: '400px',
              width: '100%'
            }}>
              <div style={{ marginBottom: '20px' }}>
                <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ margin: '0 auto' }}>
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <polyline points="14 2 14 8 20 8" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <line x1="12" y1="18" x2="12" y2="12" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <line x1="9" y1="15" x2="12" y2="18" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <line x1="15" y1="15" x2="12" y2="18" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h2 style={{ 
                marginBottom: '10px', 
                color: '#374151',
                fontSize: '24px',
                fontWeight: '600'
              }}>
                Unable to Display PDF
              </h2>
              <p style={{ 
                color: '#6B7280', 
                marginBottom: '30px',
                fontSize: '14px',
                lineHeight: '1.5'
              }}>
                Your browser cannot display this PDF. Please download it to view.
              </p>
              <button 
                onClick={handleDownload}
                style={{
                  display: 'block',
                  width: '100%',
                  padding: '14px 24px',
                  backgroundColor: '#3B82F6',
                  color: 'white',
                  borderRadius: '8px',
                  border: 'none',
                  fontWeight: '600',
                  fontSize: '16px',
                  boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
                  transition: 'all 0.2s',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#2563EB'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#3B82F6'}
              >
                📥 Download PDF
              </button>
            </div>
          </div>
        </object>
      )}
    </div>
  )
}

